/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  document.addEventListener('DOMContentLoaded', function() {

    var originalGetCart = window.cart.getCart;

    window.cart.getCart = function() {
      originalGetCart.apply(this, arguments);
      setTimeout(() => {
         checkAddonPrice();
      }, 900);
    };

  });

  function checkAddonPrice() {
    let checkInput = document.querySelector('.addon_main .addon_checkbox');
    let variantPrice = parseFloat(checkInput.getAttribute('data-price'));
    let activeCurrency = Shopify.currency.active; 

    fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      let cartTotal = data.total_price;

      if (checkInput.checked) {
        cartTotal += variantPrice;
      }
      //console.log(window.theme.formatMoney(cartTotal, window.theme.moneyFormat) + ' ' + activeCurrency)

      let moneyElement = document.querySelector('.cart__total__money');
      if (moneyElement) {
        moneyElement.textContent = window.theme.formatMoney(cartTotal, window.theme.moneyFormat) + ' ' + activeCurrency;
      } else {
        console.warn('cart__total__money element not found');
      }
    })
    .catch(error => {
      console.error('Error fetching cart total:', error);
    });
  }

})();
